import {Map} from 'immutable'

const getFaqType = (state) => state.getIn(['customization', 'payload', 'faq_type'], null);
const getFaqActive = (state) => state.getIn(['customization', 'payload','faq_on'], false);
const getColor = (state) => state.getIn(['customization', 'payload', 'color'], '#4DC1E0');
const getFrom = (state) => state.getIn(['customization', 'payload'],Map())

const getExchangeActive = (state) => state.getIn(['customization', 'payload','exchange_on'], false);


export default {
    getFrom,
    getFaqType, getFaqActive,
    getColor,
    getExchangeActive
}



// WEBPACK FOOTER //
// ./src/model/Customization/selector.js